import TextScramble from '../components/TextScramble';

export default function AdminLoginPage() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4">
      <div className="text-center">
        <h1 className="font-serif text-4xl sm:text-5xl text-white font-light mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Portail de Gestion
        </h1>
        <p className="text-white/40 text-sm mb-10">Connectez-vous avec Google pour acc&eacute;der au tableau de bord.</p>
        <button
          data-testid="google-login-btn"
          onClick={handleLogin}
          className="bg-[#F5F0E8] text-black uppercase tracking-[0.2em] text-xs font-bold px-10 py-4 hover:bg-[#EDE8DE] transition-colors"
        >
          Se connecter avec Google
        </button>
      </div>
    </div>
  );
}
